import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { RootStoreState } from 'app/root-store';
import { ProjectUserModel } from '@bsuccess/models/project/project-user.model';
import {
    StudioProjectStoreActions,
    StudioProjectStoreSelectors,
} from 'app/root-store/studio-store/project-store';
import { locale as english } from '../../../../../i18n/studio/projects/project/dialogs/project-update-members-dialog/en';
import { locale as frensh } from '../../../../../i18n/studio/projects/project/dialogs/project-update-members-dialog/fr';
import { locale as arabic } from '../../../../../i18n/studio/projects/project/dialogs/project-update-members-dialog/ar';


@Component({
    selector: 'project-update-members-dialog',
    templateUrl: './project-update-members-dialog.component.html',
    styleUrls: ['./project-update-members-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class ProjectUpdateMembersDialogComponent implements OnInit {
    error$: Observable<string>;
    members: ProjectUserModel[];
    cascade = false;
    
    constructor(
        public dialogRef: MatDialogRef<ProjectUpdateMembersDialogComponent>,
        private _store: Store<RootStoreState.State>,
        public translateService: TranslateService,
        private translationLoaderService: FuseTranslationLoaderService
    ) {
        this.dialogRef.disableClose = true;
        this.translationLoaderService.loadTranslations(english, frensh, arabic);
    }

    ngOnInit(): void {
        this._store
            .select(StudioProjectStoreSelectors.selectProjectUsers)
            .subscribe((users: ProjectUserModel[]) => {
                if (this.members) {
                    this.dialogRef.close();
                } else {
                    if (users) {
                        this.members = [...users];
                    }
                }
            });
    }

    add(): void {
        this.members.push({
            email: '',
            position: 'member',
            role: 'read',
        });
    }

    delete(index: number): void {
        this.members.splice(index, 1);
    }

    updateMember(index: number, member: ProjectUserModel): void {
        this.members[index] = member;
    }

    save(): void {
        this.members = this.members.map(_ => {
            return {
                ..._,
                email: _.email.trim()
            };
        });
        const list = this.members.filter(
            user => user.email !== '' && this.validateEmail(user.email)
        );
        if (list.length !== 0) {
            this._store.dispatch(
                StudioProjectStoreActions.updateUsers({
                    users: list.map(_ => {
                        return {
                            ..._,
                            email: _.email.trim()
                        };
                    }),
                    cascade: this.cascade
                })
            );
        }
    }

    validateEmail(email: string): boolean {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }
}
